import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { trigger, style, animate, transition } from '@angular/animations';
import { ApiService } from 'src/app/services/api.service';
import { take } from 'rxjs';

@Component({
  selector: 'app-announcement-banner',
  templateUrl: './announcement-banner.component.html',
  styleUrls: ['./announcement-banner.component.scss']
})
export class AnnouncementBannerComponent implements OnInit {
  @Input() currentUser: any;
  @Output() bannerValue = new EventEmitter<boolean>();
  announcementId!: string;
  visible = false;
  title = '';
  message = '';

  constructor(private apiService: ApiService) {}

  ngOnInit(): void {
    this.loadAnnouncement();
  }

  private loadAnnouncement(): void {
    this.apiService
      .getAnnouncement(this.currentUser?.id)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          const announcements = response?.announcement || [];

          if (announcements && Object.keys(announcements).length > 0) {
            this.title = announcements?.title || 'Announcement';
            this.message = announcements?.content || '';
            this.announcementId = announcements?.id || '';
            this.visible = true;
            this.bannerValue.emit(true);
          } else {
            this.visible = false;
            this.bannerValue.emit(false);
          }
        },
        error: () => {
          this.visible = false;
          this.bannerValue.emit(false);
        },
      });
  }

  close(): void {
    const payload = {
      userId: this.currentUser.id,
      announcementId: this.announcementId,
    };

    this.apiService
      .markAnnouncementSeen(payload)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.visible = false;
          this.bannerValue.emit(false);
        },
        error: () => {
          this.visible = false;
          this.bannerValue.emit(false);
        },
      });
  }
}
